import { safeStorage } from './safe-storage';

const XHS_CLICK_ID_QUERY_KEY = 'click_id';
const XHS_CLICK_ID_STORAGE_KEY = 'xhs_click_id';

export const persistXhsClickIdFromUrl = (): void => {
  const clickId = new URLSearchParams(window.location.search).get(XHS_CLICK_ID_QUERY_KEY);
  if (clickId) {
    safeStorage.setItem(XHS_CLICK_ID_STORAGE_KEY, clickId);
  }
};

export const getXhsClickId = (): string | undefined => {
  const clickId =
    new URLSearchParams(window.location.search).get(XHS_CLICK_ID_QUERY_KEY) ||
    safeStorage.getItem(XHS_CLICK_ID_STORAGE_KEY);
  return clickId || undefined;
};

export const clearXhsClickId = (): void => {
  safeStorage.removeItem(XHS_CLICK_ID_STORAGE_KEY);
};
